// core/services/fullscreen.service.ts
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FullscreenService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initializeFullscreenButtons() {
    const buttons = document.querySelectorAll('.fullscreen-button');
    buttons.forEach((button) => {
      this.renderer.listen(button, 'click', () => {
        const card = (button as HTMLElement).closest('.card') as HTMLElement;
        if (card) {
          if (!document.fullscreenElement) {
            card.requestFullscreen().catch((err) => {
              alert(`Error: ${err.message} (${err.name})`);
            });
          } else {
            document.exitFullscreen();
          }
        }
      });
    });
  }
}
